module.exports = __webpack_public_path__ + "img/1231110242.9641ea3d.jpg";